import { FormCard, FormItem, TextArea } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Input, Select } from 'antd'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

export enum FundingSources {
  'Local authority' = 'Local authority',
  Private = 'Private',
  'Local authority + private top-up' = 'Local authority + private top-up',
  Other = 'Other'
}

const fundingSourceOptions = Object.values(FundingSources).map((value) => ({
  label: <Text>{value}</Text>,
  value
}))

export const FundingSourceFormCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
    <FormCard title={t(supConstants.FUNDING_SOURCE)}>
      <FormItem
        label={<Text>{t(supConstants.FUNDING_SOURCE)}</Text>}
        name="fundingSource"
      >
        <Select options={fundingSourceOptions} />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.OTHER_FUNDING_SOURCE)}</Text>}
        name="fundingSourceOther"
      >
        <Input />
      </FormItem>
      <FormItem
        label={<Text> {t(supConstants.NOTE)}</Text>}
        name="fundingSourceNotes"
      >
        <TextArea
          autoSize={{
            minRows: 3
          }}
        />
      </FormItem>
    </FormCard>
  )
}
